
const { GRAPH_HOST } = require("../constants");
const { blockQuery, blocksQuery, massBlocksQuery } = require("../queries");
const { request } = require("graphql-request");
const { addSeconds, getUnixTime, startOfHour, startOfMinute, startOfSecond, subDays, subWeeks, subHours } = require("date-fns");

const BLOCKS = {
  ethereum: "blocklytics/ethereum-blocks",
  xdai: "matthewlilley/xdai-blocks",
  polygon: "matthewlilley/polygon-blocks",
  fantom: "matthewlilley/fantom-blocks",
  bsc: "matthewlilley/bsc-blocks",
  harmony: "sushiswap/harmony-blocks",
  avalanche: "matthewlilley/avalanche-blocks",
  celo: "ubeswap/celo-blocks",
  arbitrum: "sushiswap/arbitrum-blocks",
  okex: "okexchain-blocks/oec",
  heco: "hecoblocks/heco",
  moonriver: "sushiswap/moonriver-blocks",
  fuse: "sushiswap/fuse-blocks",
  kovan: "blocklytics/kovan-blocks",
  moonbeam: "sushiswap/moonbeam-blocks",
};

// @ts-ignore TYPE NEEDS FIXING
const fetcher = async (network = "ethereum", query, variables = undefined) =>
  // @ts-ignore TYPE NEEDS FIXING
  request(`${GRAPH_HOST[network]}/subgraphs/name/${BLOCKS[network]}`, query, variables)
;

// @ts-ignore TYPE NEEDS FIXING
const getBlock = async (network = "ethereum", variables) => {
  const { blocks } = await fetcher(network, blockQuery, variables);

  return { number: Number(blocks?.[0]?.number), timestamp: blocks?.[0]?.timestamp };
};

// @ts-ignore TYPE NEEDS FIXING
const getBlocks = async (network = "ethereum", variables) => {
  const { blocks } = await fetcher(network, blocksQuery, variables);
  return blocks;
};

// @ts-ignore TYPE NEEDS FIXING
const getMassBlocks = async (network = "ethereum", timestamps) => {
  const data = await fetcher(network, massBlocksQuery(timestamps));
  return Object.values(data).map((entry) => ({
    // @ts-ignore TYPE NEEDS FIXING
    number: Number(entry[0].number),
    // @ts-ignore TYPE NEEDS FIXING
    timestamp: Number(entry[0].timestamp),
  }));
};

// Grabs the last 1000 (a sample statistical) blocks and averages
// the time difference between them
const getAverageBlockTime = async (network = "ethereum") => {
  const now = startOfHour(Date.now());
  const blocks = await getBlocks(network, {
    where: {
      timestamp_gt: getUnixTime(subHours(now, 6)),
      timestamp_lt: getUnixTime(now),
    },
  });

  const averageBlockTime = blocks?.reduce(
    // @ts-ignore TYPE NEEDS FIXING
    (previousValue, currentValue, currentIndex) => {
      if (previousValue.timestamp) {
        const difference = previousValue.timestamp - currentValue.timestamp;

        previousValue.averageBlockTime = previousValue.averageBlockTime + difference;
      }

      previousValue.timestamp = currentValue.timestamp;

      if (currentIndex === blocks.length - 1) {
        return previousValue.averageBlockTime / blocks.length;
      }

      return previousValue;
    },
    { timestamp: null, averageBlockTime: 0 }
  );

  return averageBlockTime;
};

const getDayBlock = (network = "ethereum", d) => {
  const date = startOfSecond(startOfMinute(startOfHour(subDays(Date.now(), d))));
  const start = getUnixTime(date);
  const end = getUnixTime(addSeconds(date, 600));
  return getBlock(
    network,
    {
      where: {
        timestamp_gt: start,
        timestamp_lt: end,
      },
    },
  );
};

const getOneDayBlock = (network = "ethereum") => getDayBlock(network, 1);

const getOneWeekBlock = ( network = "ethereum") => {
  const date = startOfSecond(startOfMinute(startOfHour(subWeeks(Date.now(), 1))));
  const start = getUnixTime(date);
  const end = getUnixTime(addSeconds(date, 600));
  return getBlock(
    network,
    {
      where: {
        timestamp_gt: start,
        timestamp_lt: end,
      },
    }
  );
};

module.exports = {
  getBlock,
  getMassBlocks,
  getAverageBlockTime,
  getDayBlock,
  getOneDayBlock,
  getOneWeekBlock
};
